import { type UploadFile } from '@pba/media-chunked-upload';
import { useCallback } from 'react';

export const useRetryUpload = ({ file }: { file?: UploadFile }) =>
  useCallback(() => {
    file?.retry();
  }, [file]);
